// extracted by mini-css-extract-plugin
export default {"description":"_4rXDzaMDrSsMpRerUSxLb","detail":"_2JO1QTSd-TYJSscN6JTwGU","mapContainer":"_3UIz8EquslDeaS62xvSsa-","map":"_3ugkF3APWJdyYtU3oCkmOT","address":"_3qorz0OMeML0mOo3LnHQ-5"};